import React, { useEffect, useMemo } from 'react';
import { Modal } from 'antd';
import SweetAlert from '@components/Feedback/SweetAlert/Index';
import { SaveAmostra, UpdateAmostra } from '@services/Amostra/Index';
import ButtonComp from '@components/UI/Button/Index';
import InputTextModalComp from "@components/UI/InputTextModal/Index";
import TextAreaModalComp from '@components/UI/TextAreaModal/Index';
import { useForm } from 'react-hook-form';
import ValidationsAmostra from '@validations/Amostra/Validations';
import { useDispatch, useSelector } from 'react-redux';
import { carregarAmostra } from '@store/slices/amostrasSlice';
import { makeSelectAmostraByItemId } from '@store/selectors/amostrasSelector';

const AmostrasModal = ({
  visible,
  closeModal,
  idSolicitacaoProcessoItem,
  nomeItemProcesso,
}) => {
  const dispatch = useDispatch();

  const selector = useMemo(
    () => makeSelectAmostraByItemId(idSolicitacaoProcessoItem),
    [idSolicitacaoProcessoItem]
  );

  const amostrasState = useSelector(selector);

  const {
    register,
    handleSubmit,
    watch,
    reset,
    setValue,
  } = useForm();

  useEffect(() => {
    if (visible && amostrasState) {
      setValue('quantidadeTotal', amostrasState.quantidadeTotal);
      setValue('quantidadeComprometida', amostrasState.quantidadeComprometida);
      setValue('apontamentos', amostrasState.apontamentos);
    }
  }, [visible, amostrasState, setValue, reset]);

  const quantidadeTotal = watch('quantidadeTotal') || 0;
  const quantidadeComprometida = watch('quantidadeComprometida') || 0;

  const calcularPorcentagem = () => {
    const total = parseInt(quantidadeTotal);
    const comprometida = parseInt(quantidadeComprometida);
    if (!total || isNaN(total) || total === 0) return "0.00";
    return Math.min(100, ((comprometida / total) * 100).toFixed(2));
  };

  const onSubmit = async (data) => {
    const { validateFields } = ValidationsAmostra();
    const errors = validateFields(data);

    if (Object.keys(errors).length > 0) {
      const errorMessage = Object.values(errors).join("\n");
      SweetAlert.error("Erro na Validação", errorMessage);
      return;
    }

    if (parseInt(data.quantidadeComprometida) > parseInt(data.quantidadeTotal)) {
      return SweetAlert.error("Erro ao cadastrar", "Quantidade comprometida não pode ser maior que a total.");
    }

    const payload = {
      quantidadeTotal: parseInt(data.quantidadeTotal),
      quantidadeComprometida: parseInt(data.quantidadeComprometida),
      apontamentos: data.apontamentos,
    };

    try {
      SweetAlert.toastLoading();
      let result;

      if (amostrasState?.id) {
        result = await UpdateAmostra(amostrasState.id, payload);
        SweetAlert.toastSuccess("Amostra atualizada com sucesso!");
      } else {
        result = await SaveAmostra(idSolicitacaoProcessoItem, payload);
        SweetAlert.toastSuccess("Amostra cadastrada com sucesso!");
      }

      dispatch(carregarAmostra({ idProcessoItem: idSolicitacaoProcessoItem, amostras: result }));
      //closeModal();
    } catch (error) {

      const errorMessage = error.parsed?.message || 'Não foi possível salvar a amostra.';

      SweetAlert.error('Erro', errorMessage);
      console.error(error);
    }
  };

  const handleClose = () => {
    closeModal();
  };

  return (
    <div className='d-flex justify-content-center gap-2'>
      <Modal
        getContainer={false}
        title="Cadastro de Amostras"
        open={visible}
        onCancel={handleClose}
        footer={null}
        width={"45%"}
        centered
      >
        <p className="fs-6 mb-3 px-1">
          <strong>Item do Processo:</strong> {nomeItemProcesso}
        </p>

        <InputTextModalComp
          label="Quantidade Amostras"
          {...register('quantidadeTotal')}
          placeholder="Quantidade total"
          hoverMessage="Preencher com a quantidade total de amostras"
          maxLength={255}
          required
          type="number"
          onInput={(e) => {
            let value = e.target.value.replace(/[^0-9]/g, "");
            e.target.value = value.slice(0, 3).replace(/^0+/, '') || '0';
          }}
        />

        <InputTextModalComp
          label="Quantidade Comprometida"
          {...register('quantidadeComprometida')}
          placeholder="Quantidade comprometida"
          hoverMessage="Preencher com a quantidade comprometida de amostras"
          maxLength={255}
          required
          type="number"
          onInput={(e) => {
            let value = e.target.value.replace(/[^0-9]/g, "");
            e.target.value = value.slice(0, 3).replace(/^0+/, '') || '0';
          }}
        />

        <InputTextModalComp
          label="Porcentagem Comprometida"
          value={`${calcularPorcentagem()}%`}
          placeholder="Porcentagem comprometida"
          hoverMessage="Exibe a porcentagem calculada automaticamente"
          disabled
          type="text"
          className="fw-bold"
        />

        <TextAreaModalComp
          label="Apontamentos - (Descreva o que exatamente está sendo apontado)"
          {...register("apontamentos")}
          hoverMessage="Descreva aqui os apontamentos"
          placeholder="Descreva aqui os apontamentos"
          maxLength={256}
          style={{ height: '10rem', resize: 'none' }}
        />

        <div className="d-flex justify-content-end gap-2 mt-4">
          <ButtonComp
            title="SALVAR"
            onClick={handleSubmit(onSubmit)}
            buttonColor="#2b97be"
            classnameIcon="fa-regular fa-floppy-disk"
            hoverMessage="Salvar alterações"
          />
        </div>

      </Modal>
    </div>
  );
};

export default AmostrasModal;